import { AppPermission, AppRole, PredefinedRoles } from "@/types/role";
import { useAppStore } from "@/stores/app.js";
import { useRoles } from "@/queries/user.query.js";

function rolePermissions(role: AppRole): AppPermission[] {
  const legacyId = role.role_backward_compatibility_id;
  if (legacyId !== null && legacyId !== undefined) return PredefinedRoles[legacyId] ?? [];
  return role.permissions ?? [];
}

export function hasPermission(userRoles: AppRole[] | undefined, organisationId: string, permission: AppPermission): boolean {
  if (!userRoles?.length) return false;
  return userRoles
    .filter((r) => r.organization_id === organisationId)
    .some((r) => rolePermissions(r).includes(permission));
}

export function usePermissions() {
  const appStore = useAppStore();
  const { data: roles, isPending } = useRoles();

  const can = (permission: AppPermission) => computed(() => hasPermission(roles.value, appStore.currentOrganisationId, permission));

  return {
    isPending,
    canWriteCampaignAndSpaces: can(AppPermission.CAMPAIGN_WRITE),
    canWriteBillings: can(AppPermission.BILLING_WRITE),
    canInviteParticipants: can(AppPermission.INVITE_WRITE_PARTICIPANT),
    canWriteMembers: can(AppPermission.INVITE_WRITE),
    canManageOrganisation: can(AppPermission.ORGANIZATION_MANAGE),
  };
}
